import { render, staticRenderFns } from "./HengPayForm.vue?vue&type=template&id=4f1067ff&scoped=true&"
import script from "./HengPayForm.vue?vue&type=script&lang=ts&"
export * from "./HengPayForm.vue?vue&type=script&lang=ts&"
import style0 from "./HengPayForm.vue?vue&type=style&index=0&id=4f1067ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1067ff",
  null
  
)

export default component.exports